// extracted by mini-css-extract-plugin
export default {"Card":"CardSkeleton_Card__o-FJG","Header":"CardSkeleton_Header__movJi","Details":"CardSkeleton_Details__tYkzw","Title":"CardSkeleton_Title__HD4L2","Meta":"CardSkeleton_Meta__RxMlh"};